import * as React from "react";
import "../../../../assets/scss/components/toc/position/positionDetail/positionDetailMob.scss";
import EdButton from "../../../generic/edButton";
import { PLCls } from "../../../helper/addRemoveClsOfTgt";
import { IPosition } from "../../../types/components/positions/posTypes";
import { toINR } from "../../../service/numberFormat";

export interface IPositionDetailMobProps {
	onClose: () => void;
	data: IPosition;
}

const PositionDetailMob: React.FC<IPositionDetailMobProps> = (props) => {
	function onButtonClick(e: React.MouseEvent<HTMLButtonElement>) {
		console.log(e);
	}

	return (
		<div className="pos_dtl_wrap">
			<div className="pos_dtl_container">
				<div className="dtl_top_sec">
					<button className="cls" onClick={props.onClose}>
						<i className="edel-icon-close"></i>
					</button>
					<h1 className="sym">{props.data.cpName ? props.data.cpName : props.data.dpName}</h1>
					<h2 className="comp_nm">{props.data.trdSym}</h2>
					<label className="dtl_lbl">
						<label className="dtl_hd taLeft">Total MTM</label>
						<label className={"dtl_amt taRight " + PLCls(props.data.mtm)}>₹{toINR(props.data.mtm, 2)}</label>
					</label>
				</div>
				<hr className="slim_line" />
				<div className="dtls_cont ">
					<label className="dtl_lbl">
						<label className="dtl_hd taLeft">Net Quantity</label>
						<label className="dtl_amt taRight">{props.data.ntQty}</label>
					</label>
					<label className="dtl_lbl">
						<label className="dtl_hd taLeft">Avg. Price</label>
						<label className="dtl_amt taRight">
							₹{props.data.trsTyp === "B" ? toINR(props.data.avgByPrc, 2) : toINR(props.data.avgSlPrc, 2)}
						</label>
					</label>
					<label className="dtl_lbl">
						<label className="dtl_hd taLeft">LTP</label>
						<label className="dtl_amt taRight">
							<span className={"ltpNrml"}>₹{toINR(props.data.ltp, 2)}</span>
							{/* commented due the data points not recevied in API response */}
							{/* <span className="ltpPerc pos">
								{props.data.chg} ({props.data.chgP}%)
							</span> */}
						</label>
					</label>
					<label className="dtl_lbl">
						<label className="dtl_hd taLeft">Unrealized MTM</label>
						<label className={"dtl_amt taRight" + PLCls(props.data.urlzPL)}>₹{toINR(props.data.urlzPL, 2)}</label>
					</label>
					<label className="dtl_lbl">
						<label className="dtl_hd taLeft">Realized MTM</label>
						<label className="dtl_amt taRight">₹{toINR(props.data.rlzPL, 2)}</label>
					</label>
				</div>
				<hr className="slim_line" />
				<div className="dtls_cont ">
					<label className="dtl_lbl">
						<label className="dtl_hd taLeft">Buy Qty</label>
						<label className="dtl_amt taRight">{props.data.byQty}</label>
					</label>
					<label className="dtl_lbl">
						<label className="dtl_hd taLeft">Buy Price</label>
						<label className="dtl_amt taRight">₹{toINR(props.data.byAmt, 2)}</label>
					</label>
				</div>
				<hr className="slim_line" />
				<div className="dtls_cont ">
					<label className="dtl_lbl">
						<label className="dtl_hd taLeft">Sell Qty</label>
						<label className="dtl_amt taRight">{props.data.slQty}</label>
					</label>
					<label className="dtl_lbl">
						<label className="dtl_hd taLeft">Sell Price</label>
						<label className="dtl_amt taRight">₹{toINR(props.data.slAmt, 2)}</label>
					</label>
				</div>
				<hr className="slim_line" />
				<div className="dtls_cont ">
					<label className="dtl_lbl">
						<label className="dtl_hd taLeft">Product Type</label>
						<label className="dtl_amt taRight">{props.data.prdCode}</label>
					</label>
					{/* <label className="dtl_lbl">
						<label className="dtl_hd taLeft">Exposure</label>
						<label className="dtl_amt taRight">₹99,99,271.60</label>
					</label> */}
				</div>
				<div className="ob_btns mg-t40 mg-b30">
					<EdButton
						value="Add more"
						btnTyp="secondary"
						className={"add_more " + (props.data.sqOff !== "false" ? "mg-r25" : "")}
						onClick={onButtonClick}
						slim
					/>
					{props.data.sqOff !== "false" && (
						<EdButton value="Square-off" btnTyp="secondary" className="Square_off" onClick={onButtonClick} slim />
					)}
				</div>
			</div>
		</div>
	);
};

export default PositionDetailMob;
